import { Button } from '@mui/material';

import useConfirm from '@/hooks/useConfirm';
import VnModalBody from '@/modals/components/VnModalBody';
import VnModalFooter from '@/modals/components/VnModalFooter';
import type { ConfirmMessage } from '@/models/ConfirmMessage';

import { VNBaseModal } from './VNBaseModal';

export const VNConfirmModal = ({
  open = true,
  title = 'Confirm',
  subTitle,
  message,
  confirmText = 'Ok',
  cancelText = 'Cancel',
  type = 'default',
}: ConfirmMessage) => {
  const { onConfirm, onCancel } = useConfirm();
  return (
    <VNBaseModal open={open} title={title} subTitle={subTitle} onClose={onCancel ?? (() => {})}>
      <VnModalBody>{typeof message === 'string' ? <p>{message}</p> : message}</VnModalBody>
      <VnModalFooter
        right={
          <>
            <Button variant="contained" color="success" onClick={onConfirm}>
              {confirmText}
            </Button>
            <Button variant="contained" onClick={onCancel}>
              {cancelText}
            </Button>
          </>
        }
      />
    </VNBaseModal>
  );
};
